var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.745,
    height: 20.043,
    viewBox: "0 0 14.745 20.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "lock_open_FILL0_wght700_GRAD200_opsz20",
    d: "M148.825-949.621h6.534V-951.1a2.051,2.051,0,0,0-.577-1.472,1.878,1.878,0,0,0-1.413-.6,1.87,1.87,0,0,0-1.41.6,2.056,2.056,0,0,0-.574,1.472h-2.825a4.752,4.752,0,0,1,1.411-3.477A4.62,4.62,0,0,1,153.378-956a4.6,4.6,0,0,1,3.4,1.427,4.764,4.764,0,0,1,1.406,3.473v1.479h-.265a2.746,2.746,0,0,1,1.994.816,2.705,2.705,0,0,1,.831,2.01v8.013a2.72,2.72,0,0,1-.832,1.994,2.722,2.722,0,0,1-1.995.831h-9.1a2.71,2.71,0,0,1-1.991-.831,2.726,2.726,0,0,1-.828-1.994V-946.8a2.705,2.705,0,0,1,.831-2.01A2.746,2.746,0,0,1,148.825-949.621Zm0,10.838h9.094V-946.8h-9.094Zm4.555-2.274a1.605,1.605,0,0,0,1.206-.505,1.689,1.689,0,0,0,.486-1.214,1.646,1.646,0,0,0-.494-1.206,1.645,1.645,0,0,0-1.214-.5,1.61,1.61,0,0,0-1.206.5,1.672,1.672,0,0,0-.486,1.206,1.663,1.663,0,0,0,.494,1.214A1.64,1.64,0,0,0,153.381-941.056Zm-4.555,2.274v0Z",
    transform: "translate(-146 956)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLock);
export default __webpack_public_path__ + "static/media/openLock.42cb30d6972300aba614e4820930b06f.svg";
export { ForwardRef as ReactComponent };